/* ==========================================================================
   AURUM "Load More" — progressive enhancement of Dawn's numbered pagination on
   collection/search pages. Hides the numbered pager, adds a gold "Load More"
   button that fetches the next page and appends its product cards. Preserves the
   active filters/sort (the next-page URL already carries them) and re-inits after
   Dawn's facet AJAX replaces the grid. If JS is off/fails, the normal pager shows.
   ========================================================================== */
(function () {
  'use strict';
  var LABEL = 'Load More';

  function nextHrefFrom(root, current) {
    var href = null;
    var links = root.querySelectorAll('.pagination-wrapper a, .pagination__list a');
    Array.prototype.forEach.call(links, function (a) {
      var h = a.getAttribute('href') || '';
      var m = h.match(/[?&]page=(\d+)/);
      if (m && parseInt(m[1], 10) === current + 1) href = new URL(h, location.href).href;
    });
    return href;
  }

  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var grid = container.querySelector('ul#product-grid, ul.product-grid');
    var wrapper = container.querySelector('.pagination-wrapper');
    if (!grid || !wrapper || wrapper.__aurumLM) return;  // single page, or already enhanced
    wrapper.__aurumLM = true;

    var current = parseInt(wrapper.getAttribute('data-page') || '1', 10) || 1;
    var nextHref = nextHrefFrom(container, current);

    wrapper.style.display = 'none';                       // hide the numbered pager
    var bar = document.createElement('div');
    bar.className = 'aurum-loadmore';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aurum-loadmore__btn';
    btn.textContent = LABEL;
    bar.appendChild(btn);
    wrapper.parentNode.insertBefore(bar, wrapper);

    if (!nextHref) { bar.style.display = 'none'; return; }

    var loading = false;
    function load() {
      if (loading || !nextHref) return;
      loading = true;
      btn.classList.add('is-loading');
      btn.textContent = 'Loading…';
      fetch(nextHref)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('ul#product-grid, ul.product-grid');
          if (newGrid) {
            Array.prototype.forEach.call(newGrid.children, function (li) {
              var node = document.importNode(li, true);
              node.classList.remove('scroll-trigger');       // don't leave appended cards hidden by the reveal observer
              // native lazy-load is unreliable for injected nodes; the user asked to see these, so load now
              Array.prototype.forEach.call(node.querySelectorAll('img[loading="lazy"]'), function (im) {
                im.setAttribute('loading', 'eager');
              });
              grid.appendChild(node);
            });
          }
          current += 1;
          nextHref = nextHrefFrom(doc, current);
          loading = false;
          btn.classList.remove('is-loading');
          btn.textContent = LABEL;
          if (!nextHref) bar.style.display = 'none';
        })
        .catch(function () {
          loading = false;
          btn.classList.remove('is-loading');
          btn.textContent = LABEL;
          wrapper.style.display = '';                        // fall back to the numbered pager on error
          bar.style.display = 'none';
        });
    }
    btn.addEventListener('click', load);
  }

  function boot() {
    init();
    var host = document.querySelector('main') || document.body;
    if (!host || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { init(); });  // re-enhance after facet AJAX swaps the grid
    mo.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
